//#region src/utils/image-to-file.ts
async function e(e, t, n = "image/png") {
	let r = new OffscreenCanvas(e.width, e.height), i = r.getContext("2d");
	if (!i) throw Error("Canvas context is not available");
	i.drawImage(e, 0, 0);
	let a = await r.convertToBlob({ type: n });
	return new File([a], t, { type: n });
}
//#endregion
export { e as imageToFile };
